<template>
  <div class="flex flex-col gap-2 overflow-visible" :class="wrapperClass">
    <div class="flex flex-wrap gap-2 overflow-visible p-1" :class="buttonsClass">
      <button
          v-for="sport in sportOptions"
          :key="sport.value"
          type="button"
          class="group relative flex items-center justify-center rounded-2xl border
           border-border
           transition-all duration-300
           hover:ring-2 hover:ring-primary/40
           focus:outline-none focus:ring-2 focus:ring-primary
           bg-transparent"
          :class="[
          props.isCompactMode ? 'w-12 h-12' : 'flex-col w-24 h-24',
          props.selectedSport === sport.value
            ? (!isMobile
                ? 'scale-105 shadow-md ring-2 ring-primary'
                : 'ring-2 ring-primary')
            : 'border-border'
        ]"
          @mouseenter="hovered = sport.value"
          @mouseleave="hovered = null"
          @click="$emit('update:selectedSport', sport.value)"
      >
        <span
            class="transition-transform duration-300 select-none scale-[1] flex items-center justify-center p-2"
            :class="{
            'md:-translate-y-4': hovered === sport.value || props.selectedSport === sport.value,
            'scale-[0.8] md:scale-[0.8]': hovered === sport.value || props.selectedSport === sport.value
          }"
        >
          <img :src="sport.iconSvg" :alt="sport.label" class="max-w-[100%] max-h-[100%] object-contain" />
        </span>

        <span
            v-if="!isMobile && !props.isCompactMode"
            class="absolute text-center text-xs font-medium transition-all duration-300 ease-out select-none"
            :class="labelClass(sport.value)"
        >
          {{ sport.label }}
        </span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, inject, onMounted, onUnmounted, ref} from 'vue'
import {SportData} from "@/composables/useSports";
import {KEY_IS_MOBILE} from "@/keys/keys";

const props = defineProps({
  selectedSport: {type: String as () => string | undefined, default: undefined},
  sportOptions: {type: Array as () => SportData[], required: true},
  isCompactMode: Boolean,
})

defineEmits(['update:selectedSport'])

const windowWidth = ref(window.innerWidth)
const onResize = () => (windowWidth.value = window.innerWidth)
onMounted(() => window.addEventListener('resize', onResize))
onUnmounted(() => window.removeEventListener('resize', onResize))

const isMobile = inject(KEY_IS_MOBILE)
const hovered = ref<string | null>(null)

const wrapperClass = computed(() => {
  if (!props.isCompactMode) return 'items-center justify-center'
  if (isMobile?.value) return 'items-center'
  return ''
})

const buttonsClass = computed(() => {
  if (!props.isCompactMode || isMobile?.value) return 'justify-center'
  return ''
})

function labelClass(sportValue: string) {
  const isActive = hovered.value === sportValue || props.selectedSport === sportValue
  return [
    isActive
        ? 'opacity-100 top-1/2 left-1/2 -translate-x-1/2 translate-y-3.5 text-foreground'
        : 'opacity-0 top-1/2 left-1/2 -translate-x-1/2 translate-y-0 text-muted-foreground',
  ]
}
</script>

<style scoped>
button span.absolute {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
</style>